import { Checkbox } from '@mui/material';

import { styled } from '#/src/theme';

export const KonfoCheckbox = styled(Checkbox)({
  padding: '0 9px',
});
